import { AffinyEndpoint } from 'affiny-core/modules/api/core/affinyEndpoints/affiny.endpoints';
import { paginatedRequest } from 'affiny-core/modules/helpers';
import { EAffinyEventOrigin } from '../affiny.eventorigins';

export const MessagesResource = {
  postMessage: (
    myAboid: string,
    otherAboid: string,
    isDryRun: boolean,
    content = '',
    eventOrigin: EAffinyEventOrigin
  ) =>
    AffinyEndpoint.Message.url(
      `/${myAboid}/${otherAboid}/${isDryRun ? '?dryrun' : ''}`
    )
      .headers({ 'X-Event-Origin': eventOrigin })
      .post({ data: { type: 'message', attributes: { content } } })
      .json(),

  getMessages: (
    myAndOtherAcccountId: string,
    pageNumber: number,
    pageSize: number
  ) =>
    paginatedRequest({
      apiEndPoint: AffinyEndpoint.Message.url(`/${myAndOtherAcccountId}/`),
      pageNumber,
      pageSize,
    }),
};
